import { useQuery } from '@tanstack/react-query'
import { fetchRegionsByNation } from '@/services/regions'

export function useRegionsByNation(nationId: string | undefined) {
  const regionsQuery = useQuery({
    queryKey: ['regions', 'nation', nationId],
    queryFn: () => fetchRegionsByNation(nationId!),
    enabled: !!nationId,
  })

  return {
    regions: regionsQuery.data,
    isLoading: regionsQuery.isLoading,
    error: regionsQuery.error,
  }
}
